export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const CRYPTO_KEY = process.env.REACT_APP_CRYPTO_KEY;
export const GOOGLE_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
